
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Csbserviceinkharadi() {



const cardData = {
  keyword: 'Corporate Cab Services in Kharadi MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Kharadi MIDC',
  headingDescription: `eTravo provides dependable and professional corporate cab services in Kharadi MIDC, tailored to meet the diverse transportation requirements of businesses and employees in this rapidly growing industrial and IT hub. Whether it’s daily staff commutes, executive travel, client pickups, or airport transfers, our fleet ensures punctuality, safety, and comfort. With GPS-enabled vehicles, courteous drivers, and customizable booking plans, eTravo supports seamless corporate travel across Kharadi and nearby areas. Our services are designed to boost operational efficiency while offering a hassle-free travel experience.`,

  top: 'Top Industrial and IT Landmarks in Kharadi MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'EON Free Zone',
      description: `A major IT park and commercial hub in Kharadi, housing numerous multinational companies and startups. eTravo offers scheduled and on-demand cab services catering to the commuting needs of employees, ensuring timely and comfortable rides throughout the day.`
    },
    {
      title: 'Zensar Technologies',
      description: `A prominent IT services company located in Kharadi MIDC. Our corporate cab services provide reliable and safe daily commute solutions for employees, enhancing punctuality and convenience for the workforce.`
    },
    {
      title: 'Ruby Hall Clinic Kharadi',
      description: `A leading healthcare facility in the area. eTravo offers cab services for medical staff and patients, ensuring comfortable and timely transportation.`
    },
    {
      title: 'The Capitol Complex',
      description: `An upcoming commercial and business complex. We support corporate shuttle services and client transport solutions to meet diverse business travel demands.`
    },
    {
      title: 'Kharadi IT Park',
      description: `A key destination for tech companies and offices in the region. Our corporate cab fleet ensures smooth transportation for employees working on tight schedules.`
    }
  ],

  services: [
    {
      name: 'Kharadi MIDC Corporate Cab Rentals',
      description: `Tailored cab rental packages for businesses operating in Kharadi MIDC, including fixed-term and flexible rental plans. Our services cater to daily staff commutes, corporate events, and executive travel needs, ensuring reliable and cost-effective mobility solutions.`
    },
    {
      name: 'Employee Transport Cab Kharadi MIDC',
      description: `Daily and on-call cab services for employees commuting to offices in Kharadi MIDC. Our fleet includes modern, GPS-tracked vehicles driven by professional chauffeurs, guaranteeing safe and timely transportation aligned with shift timings.`
    },
    {
      name: 'Business Cab Services Kharadi MIDC',
      description: `Professional cab services designed for business owners, visiting clients, and field agents. We offer a variety of vehicle options from sedans to premium SUVs, focusing on comfort, reliability, and timely arrivals.`
    },
    {
      name: 'Corporate Staff Cabs Kharadi MIDC',
      description: `Structured transportation solutions for corporate staff with multi-stop routes, shift-based schedules, and real-time fleet tracking. Our service helps streamline daily commutes and enhances workforce productivity.`
    },
    {
      name: 'Reliable Corporate Cab Service Kharadi MIDC',
      description: `Trusted by numerous companies in Kharadi MIDC, our corporate cab service emphasizes punctuality, vehicle cleanliness, and courteous drivers, ensuring a seamless daily commute experience and dependable business travel.`
    },
    {
      name: 'AC Corporate Cabs Kharadi MIDC',
      description: `All our cabs are fully air-conditioned, sanitized regularly, and maintained for maximum comfort. This ensures a pleasant ride for your employees and clients even during peak summer months or monsoon season.`
    },
    {
      name: 'Staff Pickup and Drop Cab Kharadi MIDC',
      description: `Round-the-clock employee pickup and drop services that accommodate shift timings and departmental requirements. Our well-planned scheduling maximizes efficiency and ensures employees reach their workplace safely and on time.`
    },
    {
      name: 'Affordable Business Cab Rentals Kharadi MIDC',
      description: `Cost-effective cab rental solutions designed for startups and small to large enterprises, featuring flexible billing options,  capabilities, and monthly contract plans tailored to your budget and operational needs.`
    },
    {
      name: 'Executive Cab Services Kharadi MIDC',
      description: `Premium cab services crafted for company executives and VIP clients. Our fleet includes luxury vehicles, professionally dressed chauffeurs, and a commitment to absolute punctuality and discretion.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Kharadi MIDC',
      description: `Comprehensive employee transportation with monthly plans offering fixed routes, shift-based arrangements, and live GPS tracking to enhance safety, transparency, and operational convenience for your business.`
    },
    {
      name: 'Industrial Area Employee Transport Kharadi MIDC',
      description: `End-to-end coordination of employee transport across industrial and commercial zones in Kharadi MIDC, including multi-stop business routing and team transfers, supporting smooth business operations.`
    },
    {
      name: 'Corporate Client Cabs Kharadi MIDC',
      description: `Professional cab services for business meetings, client visits, and corporate events, ensuring timely arrivals, a comfortable travel environment, and a positive impression for your clients.`
    },
    {
      name: 'Business Meeting Cabs Kharadi MIDC',
      description: `On-demand taxi services for quick and flexible travel within Kharadi MIDC and adjacent areas, tailored to meet last-minute business meeting needs and ensuring responsiveness.`
    },
    {
      name: 'Kharadi Industrial Area Cab Hire',
      description: `Dedicated cab hire services focusing on staff transportation, inter-office travel, and special events, with a strong emphasis on reliability, safety, and comfort.`
    },
    {
      name: 'Corporate Shuttle Cabs Kharadi MIDC',
      description: `Professional shuttle services designed for efficient group transportation during corporate events, meetings, or daily staff commutes, ensuring timely pickups and drop-offs.`
    }
  ],

  tableData: [
    ['Kharadi MIDC Corporate Cab Rentals', 'Employee Transport Cab Kharadi MIDC'],
    ['Business Cab Services Kharadi MIDC', 'Corporate Staff Cabs Kharadi MIDC'],
    ['Reliable Corporate Cab Service Kharadi MIDC', 'AC Corporate Cabs Kharadi MIDC'],
    ['Staff Pickup and Drop Cab Kharadi MIDC', 'Affordable Business Cab Rentals Kharadi MIDC'],
    ['Executive Cab Services Kharadi MIDC', 'Monthly Corporate Cab Rentals Kharadi MIDC'],
    ['Industrial Area Employee Transport Kharadi MIDC', 'Corporate Client Cabs Kharadi MIDC'],
    ['Business Meeting Cabs Kharadi MIDC', 'Kharadi Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Kharadi MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Smart Cab Solutions for Kharadi MIDC Businesses",
    "WhyChoosedescription": "eTravo provides reliable and modern corporate cab services for companies operating in Kharadi MIDC—an evolving hub for IT, manufacturing, and logistics businesses in Pune. With increasing demand for efficient employee transportation in a high-traffic zone, our solutions are crafted to ensure timely pickups, comfortable rides, and enhanced productivity. Whether you're managing shift operations, executive meetings, or inter-facility logistics, our services offer seamless mobility with operational precision."
  },
  {
    "WhyChooseheading": "Versatile Fleet for Every Corporate Use Case",
    "WhyChoosedescription": "We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and MUVs to match varying business needs. Whether it's a daily shuttle for your workforce, VIP transfers, or inter-city logistics support, our fleet ensures safe, clean, and reliable transport every time."
  },
  {
    "WhyChooseheading": "Professionally Trained Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are experienced and trained in professional etiquette and defensive driving. Their familiarity with Kharadi’s tech parks, commercial buildings, and traffic hotspots ensures timely travel and hassle-free navigation, especially during peak business hours."
  },
  {
    "WhyChooseheading": "Shift-Compatible Booking and 24/7 Availability",
    "WhyChoosedescription": "Kharadi’s workforce often operates around the clock. eTravo supports this with flexible ride scheduling, shift-based transport solutions, and 24/7 availability—ensuring no employee is left waiting regardless of time or weather conditions."
  },
  {
    "WhyChooseheading": "Live Trip Monitoring via GPS Integration",
    "WhyChoosedescription": "All our vehicles are GPS-enabled, allowing HR or admin teams to track rides in real-time, monitor driver behavior, and maintain accurate records for safety and efficiency. Our control center also keeps a close eye on trip status to support quick resolution in case of delays or reroutes."
  },
  {
    "WhyChooseheading": "Transparent Billing and Automated Invoicing",
    "WhyChoosedescription": "eTravo simplifies corporate billing by offering monthly invoicing with detailed ride logs, GST-compliant statements, and expense summaries. This transparency helps your finance team manage budgets, audits, and reimbursement with complete accuracy."
  },
  {
    "WhyChooseheading": "Best-in-Class Safety & Hygiene Protocols",
    "WhyChoosedescription": "We maintain a strict sanitization schedule for our cabs and enforce driver hygiene practices, including regular health screenings. These safety protocols are designed to give employees peace of mind, especially during long commutes or in rides."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Support with Account Managers",
    "WhyChoosedescription": "Every corporate client is supported by a dedicated account manager who ensures smooth onboarding, real-time support, and route optimization based on your team's location and shift structure. This personalized attention helps streamline daily operations and improves service responsiveness."
  }
]
}

const faqData = [
  [
    {
      question: "Do your services cover all business parks in Kharadi MIDC?",
      answer: "Yes, we serve all key areas including EON IT Park, World Trade Center, Zensar Tech Park, and nearby commercial zones within Kharadi MIDC."
    },
    {
      question: "Can we schedule transportation for multiple shifts?",
      answer: "Absolutely. Our platform supports fixed and rotating shift schedules with automatic reminders and optimized route planning."
    },
    {
      question: "Do you offer consolidated monthly billing for all rides?",
      answer: "Yes, we offer GST-compliant monthly invoices with detailed trip reports to help with finance reconciliation and HR expense tracking."
    },
    {
      question: "How do you ensure employee safety during rides?",
      answer: "We use GPS tracking, driver background verification, real-time monitoring, and regular sanitization to ensure complete ride safety."
    },
    {
      question: "Are your drivers trained in corporate protocols?",
      answer: "Yes, our drivers are trained in professional behavior, safety protocols, and are familiar with corporate travel standards."
    },
    {
      question: "Will we have a point of contact for support?",
      answer: "Yes, each business account is assigned a dedicated account manager for continuous support, scheduling, and service customization."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Abhishek Kulkarni",
    designation: "Admin Lead, Zenith Software Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services have been a game-changer for our shift teams in Kharadi. On-time arrivals and excellent driver behavior have made commuting stress-free.”"
  },
  {
    name: "Ms. Neha Rane",
    designation: "HR Manager, InfoCore Technologies",
    rating: [1, 1, 1, 1, 1],
    text: "“We’ve seen improved employee satisfaction since onboarding eTravo. Their billing system, flexibility, and support team are top-notch.”"
  }
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kharadi MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-kharadi-midc.jpg",
  "description": "Reliable corporate cab service in Kharadi MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-kharadi-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Kharadi MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Kharadi MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Csbserviceinkharadi;